import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  ChartDataLabels,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

const HorizontalBarChart = () => {
  // Chart data
  const data = {
    labels: [
      "North America",
      "Europe",
      "Asia Pacific",
      "Latin America",
      "Middle East & Africa",
      "China",
      "India",
      "Japan",
      "Germany",
      "France",
    ],
    datasets: [
      {
        label: "Market Size (in $ Million)",
        data: [
          81123.5, 64757.9, 42065.1, 33046.7, 24682.9, 18682.9, 11682.9, 9682.9,
          6682.9, 3682.9,
        ],
        backgroundColor: "#923351",
        barThickness: 30,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => `$${tooltipItem.raw.toFixed(1)}M`,
        },
      },
      datalabels: {
        anchor: "end",
        align: "right",
        formatter: (value) => `${(value / 1000).toFixed(1)}K`,
        color: "#000",
        font: {
          size: 13,
          weight: 500,
        },
      },
    },
    scales: {
      x: {
        ticks: {
          callback: (value) => `$${value / 1000}K`,
          font: {
            family: "Poppins",
            size: 14,
          },
          color: "#000",
        },
        beginAtZero: true,
        border: {
          display: false,
        },
      },
      y: {
        ticks: {
          font: {
            family: "Poppins",
            size: 14,
          },
          color: "#000",
          callback: function (value, index) {
            const label = this.getLabelForValue(value);
            const maxLength = 14;
            if (label.length > maxLength) {
              return label.match(new RegExp(".{1," + maxLength + "}", "g"));
            }
            return label;
          },
        },
        grid: {
          display: false,
        },
        border: {
          color: "#4a4a4a",
          width: 2,
        },
      },
    },
    layout: {
      padding: {
        right: 50,
        left: 10,
      },
    },
  };

  return (
    <div className="py-8">
      <div className=" p-6 bg-white rounded-lg shadow border1 font-inter">
        <div className="container mx-auto">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold font4">
              Global XYZ Market Size Study & Forecast By Top Countries 2022-2033
              ($ Million)
            </h2>
            <button className="bg-black text-white px-14 py-2 rounded-xl font-semibold text-center hover:bg-[#21242a]">
              Download
            </button>
          </div>
          <div className="relative h-[500px] mb-2">
            <Bar data={data} options={options} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HorizontalBarChart;
